export default __webpack_public_path__ + "static/media/north-pole-label.552c1c04.png";